import { ChangeEvent, useState } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useToast,
} from '@chakra-ui/react';
import { CompleteUserBook, NewUserBook, UserCreatedBooksService } from '../../../generated/client';
import React from 'react';
import { UserBookServiceFactory } from '../ServiceFactrories/UserBookServiceFactory';

interface Props {
  isCreateNewBookMode: boolean;
  book?: CompleteUserBook;
  isOpen: boolean;
  userId: string;
  closeModal: () => void;
  refreshList: () => void;
}

export function UserBookCreationComponent({
  isCreateNewBookMode,
  book,
  isOpen,
  userId,
  closeModal,
  refreshList,
}: Props): JSX.Element {
  const [updatedContent, setUpdatedContent] = useState(book ? book.content : '');
  const [updatedTitle, setUpdatedTitle] = useState(book ? book.title : '');
  const [updatedAuthorName, setUpdatedAuthorName] = useState(book ? book.authors[0].name : '');
  const userBookServiceFactory: UserCreatedBooksService = UserBookServiceFactory.instance();
  const toast = useToast();

  const handleContentUpdate = (event: ChangeEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    setUpdatedContent(event.target.value);
  };

  const handleTitleUpdate = (event: ChangeEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    setUpdatedTitle(event.target.value);
  };

  const handleAuthorUpdate = (event: ChangeEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    setUpdatedAuthorName(event.target.value);
  };

  const handleCloseModalClearData = () => {
    setUpdatedContent(book ? book.content : '');
    setUpdatedTitle(book ? book.title : '');
    setUpdatedAuthorName(book ? book.authors[0].name : '');
    closeModal();
  };

  const handleSaveBook = async () => {
    if (!isCreateNewBookMode && book) {
      const dataToSend: CompleteUserBook = {
        id: book.id,
        comments: book.comments ?? [],
        ratings: book.ratings ?? [],
        isPublic: book.isPublic,
        title: updatedTitle,
        content: updatedContent,
        authors: [
          {
            name: updatedAuthorName,
            id: userId,
          },
        ],
      };
      await userBookServiceFactory.updateBook(book.id, dataToSend);
      await refreshList();
      closeModal();
      toast({
        title: 'Book saved!',
        status: 'success',
        position: 'top-right',
      });
    } else {
      const dataToSend: NewUserBook = {
        title: updatedTitle,
        content: updatedContent,
        authors: [
          {
            name: updatedAuthorName,
            id: userId,
          },
        ],
      };
      await userBookServiceFactory.createBook(dataToSend);
      await refreshList();
      handleCloseModalClearData();
      toast({
        title: 'Book created!',
        status: 'success',
        position: 'top-right',
      });
    }
  };

  return (
    <Box>
      <Modal isOpen={isOpen} onClose={handleCloseModalClearData}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Writing Center</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>
              Edit the title and content of your book below. When you are done, save your changes!
            </p>
            <br />
            <p>
              <b>Book Title:</b>
            </p>
            <textarea
              style={{
                height: 50,
                width: 400,
                outlineStyle: 'solid',
                outlineColor: 'gray',
                outlineWidth: '1px',
                padding: 10,
              }}
              value={updatedTitle}
              onChange={handleTitleUpdate}
            />
            <br />
            <p>
              <b>Author Name:</b>
            </p>
            <textarea
              style={{
                height: 50,
                width: 400,
                outlineStyle: 'solid',
                outlineColor: 'gray',
                outlineWidth: '1px',
                padding: 10,
              }}
              value={updatedAuthorName}
              onChange={handleAuthorUpdate}
            />
            <br />
            <p>
              <b>Book Content:</b>
            </p>
            <textarea
              style={{
                height: 300,
                width: 400,
                outlineStyle: 'solid',
                outlineColor: 'gray',
                outlineWidth: '1px',
                padding: 10,
              }}
              value={updatedContent}
              onChange={handleContentUpdate}
            />
            <Button
              style={{ width: 400, marginBottom: 10 }}
              colorScheme='teal'
              onClick={handleSaveBook}>
              Save
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
